// removed by extract-text-webpack-plugin
module.exports = {"container":"_2nh5d","selectIcon":"_1qiuj","select":"_1oAtP","borders":"_1wdty"};


//////////////////
// WEBPACK FOOTER
// ./app/components/select/select-mobile.scss
// module id = 848
// module chunks = 3 4 5 6 7